export enum FullStoryEvent {
  FS_LOAD_WORKFLOW_EVENT = "workflow_loaded",
  FS_VIEW_STAGE_EVENT = "view_stage",
  FS_TIME_AGO_TO_FULL_TIME_EVENT = "time_ago_to_full_time",
  FS_CMD_K_OPEN_EVENT = "cmd_k_opened",
  FS_TWILIO_INCOMING_CALL = "twilio_incoming_call",
  FS_TWILIO_OUTGOING_CALL = "twilio_outgoing_call",
  FS_TWILIO_DISCONNECT_RETRIES_LIMIT = "twilio_disconnect_retries_limit",
  FS_SELECT_DEAL_LINK_TEMPLATE = "select_template_to_generate_resume_application_link",
  FS_CMD_K_FILE_UPLOAD_INVALID_EVENT = "cmd_k_file_upload_file_error",
  FS_CMD_K_VISIBILITY_CHANGED = "cmd_k_visibility_changed",
  FS_DEAL_ACTIVITY_TYPE_CHANGED = "deal_activity_type_changed",
  FS_DEAL_EMAIL_THREAD_OPENED = "deal_email_thread_opened",
}

export enum AmplitudeEvent {
  DealStageViewed = "Deal Stage Viewed",
  DealStageChanged = "Deal Stage Changed",
  DataOrchestrationRun = "Data Orchestration Run",
  DealKilled = "Deal Killed",
}
